<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="start center">
    <div style="background-color: white" fxFlexFill>
        <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">
            Depository/Custodian
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" style="height:40px;">{{ depository }}</div>
        <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Delivered
            Commodities for Depository Confirmation ({{transferredCount}})</div>
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="transferredDataSource" matSort #transferredSort="matSort">
                <!-- Trade Number Column -->
                <ng-container matColumnDef="tradeNum">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction No. </th>
                    <td mat-cell *matCellDef="let element"> {{ element.tradeNum }} </td>
                </ng-container>
                <!-- Trade Number Column -->
                <ng-container matColumnDef="tradeDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Trade Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.tradeDate  | date: 'MM/dd/yyyy' }} </td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{ element.comdyDesc }} </td>
                </ng-container>
                <!-- Quantity Type -->
                <ng-container matColumnDef="unitBal">
                    <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Quantity </th>
                    <td mat-cell class="cell-align-right" *matCellDef="let element"> {{ element.unitBal}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="transferredColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: transferredColumns;"></tr>
            </table>
            <mat-paginator #transferredPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" style="height:50px;">
            <div [ngClass]="{'disabled-button': disableRequestButton, 'enabled-button': !disableRequestButton}" >
                <div class="request-confirmation-wrapper" fxLayout="row" fxLayoutAlign="center center">
                    <div class="request-confirmation-button" fxLayout="row" fxLayoutAlign="center center" (click)="onRequestConfirmationClick()">Request
                        Confirmation
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Depository
            Confirmation Request Status ({{ validationRequestCount }})</div>
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="validationRequestDataSource" matSort #requestTable="matTable" #validationRequestSort="matSort">
                <!-- Trade Date Column -->
                <ng-container matColumnDef="queuedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Queued Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.timestamp | date: 'MM/dd/yyyy' }} </td>
                </ng-container>
                <!-- Trans. # Column -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
                </ng-container>
                <!-- Position Type -->
                <ng-container matColumnDef="processedDate">
                    <th mat-header-cell *matHeaderCellDef> Processed Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.processedDate | date: 'MM/dd/yyyy'}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="validationRequestColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: validationRequestColumns;"></tr>
            </table>
            <mat-paginator #validationRequestPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
            </mat-paginator>
        </div>
    </div>
</div>